import React from "react";
import { Button } from "../ui/button";
import avatar from "../../Data/hedi.webp";
import resumeEN from "../../Data/hediboumaizaresume.pdf";
import resumeFR from "../../Data/hediboumaizaresumefr.pdf";
import { useLang } from "../../context/LanguageContext";
import { t } from "../../translations";

export default function Hero() {
    const { lang } = useLang();
    const tr = t[lang].hero;
    const resume = lang === "fr" ? resumeFR : resumeEN;
    const resumeFilename = lang === "fr" ? "Hedi_Bou_Maiza_CV_FR.pdf" : "Hedi_Bou_Maiza_Resume_EN.pdf";

    return (
        <section
            id="hero"
            className="relative flex flex-col justify-center items-center text-center min-h-[72vh] sm:min-h-[78vh] pt-24 pb-10 sm:pb-12 px-6 sm:px-10 md:px-16 bg-gradient-to-b from-blue-50 via-bg to-purple-50 dark:from-[#0a0a12] dark:via-black dark:to-[#0f0a14] overflow-hidden"
        >
            {/* Avatar */}
            <div className="flex justify-center mb-4 sm:mb-5">
                <div className="animate-[float_6s_ease-in-out_infinite] hover:animate-none">
                    <div className="relative w-28 h-28 sm:w-36 sm:h-36 md:w-48 md:h-48 rounded-full bg-gradient-to-br from-blue-200 to-blue-300 flex items-center justify-center text-blue-700 font-bold border-4 border-surface-elevated shadow-xl transform hover:scale-105 transition-transform duration-500 group">
                        <div className="absolute -inset-1 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full opacity-20 group-hover:opacity-30 blur-xl transition-opacity duration-500 animate-pulse"></div>
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 to-purple-500/20 rounded-full group-hover:opacity-0 transition-opacity duration-500"></div>
                        <div className="relative z-10 w-full h-full">
                            <img
                                src={avatar}
                                alt="Hedi Bou Maiza"
                                className="w-full h-full object-cover rounded-full"
                                fetchPriority="high"
                                decoding="async"
                            />
                        </div>
                        <div className="absolute inset-0 rounded-full shadow-lg opacity-50 group-hover:opacity-75 transition-opacity duration-500"></div>
                    </div>
                </div>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tightest mb-2 sm:mb-3 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 leading-[1.05]">
                Hedi Bou Maiza
            </h1>
            <h2 className="text-lg sm:text-xl md:text-2xl font-semibold tracking-tight mb-2 sm:mb-3 text-label">
                {tr.subtitle}
            </h2>
            <p className="text-[15px] sm:text-base mb-6 text-label-secondary max-w-sm sm:max-w-md leading-relaxed">
                {tr.description}
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 w-full max-w-sm sm:max-w-none">
                <Button
                    size="lg"
                    className="w-full sm:w-auto"
                    onClick={() => {
                        const link = document.createElement("a");
                        link.href = resume;
                        link.download = resumeFilename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }}
                >
                    <span className="flex items-center justify-center space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
                        </svg>
                        <span className="font-semibold">{tr.downloadResume}</span>
                    </span>
                </Button>
                <Button
                    variant="outline"
                    size="lg"
                    className="w-full sm:w-auto"
                    onClick={() => {
                        const contactSection = document.getElementById("contact");
                        contactSection?.scrollIntoView({ behavior: "smooth" });
                    }}
                >
                    <span className="font-semibold">{tr.contactMe}</span>
                </Button>
            </div>
        </section>
    );
}
